import FaqPage from './FaqPage';
import React, { Component, Fragment } from 'react';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import { AppNotificationView, TermsDialogView } from './components/views';
import NewsPage from './NewsPage';
import PricingPage from './PricingPage';
import SamplesPage from './SamplesPage';
import LandingHubPage from './LandingHubPage';
import { TAGGIS_ELEARNING_ROUTES, TAGGIS_QR_ROUTES } from './constants';
import TaggisElearningLanding from './TaggisElearningLanding';
import TaggisQrLanding from './TaggisQrLanding';

export default class Router extends Component {
	render () {
		return (
			<BrowserRouter>
				<Fragment>
					<Switch>
						<Route
							path={TAGGIS_ELEARNING_ROUTES.faq}
							render={() => {
								return <FaqPage />;
							}}
						/>
						<Route
							path={TAGGIS_ELEARNING_ROUTES.news}
							render={() => {
								return <NewsPage />;
							}}
						/>
						<Route
							path={TAGGIS_ELEARNING_ROUTES.pricing}
							render={() => {
								return <PricingPage />;
							}}
						/>
						<Route
							path={TAGGIS_ELEARNING_ROUTES.samples}
							render={() => {
								return <SamplesPage />;
							}}
						/>
						<Route
							path={TAGGIS_ELEARNING_ROUTES.root}
							render={() => {
								return <TaggisElearningLanding />;
							}}
						/>
						<Route
							path={TAGGIS_QR_ROUTES.root}
							render={() => {
								return <TaggisQrLanding />;
							}}
						/>
						<Route component={LandingHubPage} />
					</Switch>
					<Route path={TAGGIS_QR_ROUTES.privacy} render={ () => <TermsDialogView />} />
					<AppNotificationView />
				</Fragment>
			</BrowserRouter>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Router.js